// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-menu_wrapper__0L6q4 {
  width: calc(100% - 27px);
  padding-left: 14px;
  padding-right: 14px;
  display: flex;
  flex-direction: column;
  align-items: left;
  height: 100vh;
}

.left-menu_logoWrapper__T\\+FZr {
  margin-top: 12px;
}

.left-menu_menuWrapper__GqGCH {
  margin-top: 24px;
}

.left-menu_menuItem__JCFIh {
  padding: 8px 8px 6px 8px;
  margin-bottom: 6px;
  display: flex;
  justify-content: left;
}
  
.left-menu_menuItem__JCFIh p {
  margin-left: 8px;
}

.left-menu_menuItemActive__0WmIB {
  background: var(--mui-palette-secondary-400);
  border-radius: 12px;
}

.left-menu_submenuWrapper__70fX2 {
  padding-left: 24px;
  margin-top: 6px;
}

.left-menu_submenuItem__M8Yzh {
  padding-left: 12px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-bottom: 2px;
}

.left-menu_menuItem__JCFIh:hover, .left-menu_submenuItem__M8Yzh:hover {
  background: var(--mui-palette-primary-100);
  border-radius: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/left-menu/index.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB","sourcesContent":[".wrapper {\n  width: calc(100% - 27px);\n  padding-left: 14px;\n  padding-right: 14px;\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  height: 100vh;\n}\n\n.logoWrapper {\n  margin-top: 12px;\n}\n\n.menuWrapper {\n  margin-top: 24px;\n}\n\n.menuItem {\n  padding: 8px 8px 6px 8px;\n  margin-bottom: 6px;\n  display: flex;\n  justify-content: left;\n}\n  \n.menuItem p {\n  margin-left: 8px;\n}\n\n.menuItemActive {\n  background: var(--mui-palette-secondary-400);\n  border-radius: 12px;\n}\n\n.submenuWrapper {\n  padding-left: 24px;\n  margin-top: 6px;\n}\n\n.submenuItem {\n  padding-left: 12px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  margin-bottom: 2px;\n}\n\n.menuItem:hover, .submenuItem:hover {\n  background: var(--mui-palette-primary-100);\n  border-radius: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `left-menu_wrapper__0L6q4`,
	"logoWrapper": `left-menu_logoWrapper__T+FZr`,
	"menuWrapper": `left-menu_menuWrapper__GqGCH`,
	"menuItem": `left-menu_menuItem__JCFIh`,
	"menuItemActive": `left-menu_menuItemActive__0WmIB`,
	"submenuWrapper": `left-menu_submenuWrapper__70fX2`,
	"submenuItem": `left-menu_submenuItem__M8Yzh`
};
export default ___CSS_LOADER_EXPORT___;
